<template>
  <div class="d-flex flex-column align-center justify-center text-center px-6">
    <v-img :src="rubraIcon" :width="96" :height="96" alt="rubra" class="mb-6 rounded-xl flex-grow-0" />
    <p class="text-h6 font-weight-semibold text-neutral900 mb-0">
      {{ $t('page.share.adding') }}
    </p>
  </div>
</template>

<script setup>
import rubraIcon from '@/assets/img/rubra_400x400.png'
</script>
